import 'ses'
import '../core/lockdown'
import { createRoot } from 'react-dom/client'

import { Client } from './world-client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './components/Home'
import './tailwind.css'

import { LaserEyesProvider } from '@omnisat/lasereyes-react'
import { MAINNET } from '@omnisat/lasereyes-core'
import { OnchainKitProvider } from '@coinbase/onchainkit'
import { MiniKitProvider } from '@coinbase/onchainkit/minikit'
import { base } from 'viem/chains'

let PUBLIC_WS_URL = env.PUBLIC_WS_URL

function App() {
  return (
    <MiniKitProvider>
    <OnchainKitProvider apiKey="PP6crH16Cc2TWtZ0qLJIIIIvbCmIBFTk" chain={base}>
      <LaserEyesProvider config={{ network: MAINNET }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/xverse/connect" element={<Home />} />
            <Route path="/world" element={<Client wsUrl={PUBLIC_WS_URL} />} />
            <Route
              path="/world/:worldName/:id?"
              element={<Client wsUrl={PUBLIC_WS_URL} />}
            />
          </Routes>
        </BrowserRouter>
      </LaserEyesProvider>
    </OnchainKitProvider>
    </MiniKitProvider>
  )
}

const root = createRoot(document.getElementById('root'))
root.render(<App />)
